import styles from './Walkme.module.scss'

const Help = ({ title, content, children }) => (
  <div className={styles.dialog}>
    {title && <h2>{title}</h2>}
    <p>{content || children}</p>
  </div>
)

export default Help
